import React from 'react';
import { css } from '@emotion/react';
import { withEuiTheme } from '../../../../src/services';
import { EuiIcon } from '../../../../src/components/icon';
import { EuiText } from '../../../../src/components/text';
class Block extends React.Component {
  render() {
    const {
      theme
    } = this.props;
    const divStyle = /*#__PURE__*/css("background:", theme.euiTheme.colors.lightShade, ";padding:", theme.euiTheme.size.xl, ";border-radius:", theme.euiTheme.border.radius.medium, ";;label:Block;");
    return <EuiText css={divStyle}>
        <p>
          <EuiIcon type="faceHappy" /> This box has it&apos;s background,
          padding, and border-radius controlled by custom css
        </p>
      </EuiText>;
  }
}
export const ConsumingHOC = withEuiTheme(Block);
try {
  ConsumingHOC.__docgenInfo = {
    tags: {},
    filePath: '/app/src-docs/src/views/theme/consuming_hoc.tsx',
    description: '',
    displayName: 'ConsumingHOC',
    methods: [],
    props: {
      ref: {
        defaultValue: null,
        description: '',
        name: 'ref',
        parent: {
          fileName: 'app/node_modules/@types/react/index.d.ts',
          name: 'RefAttributes'
        },
        declarations: [{
          fileName: 'app/node_modules/@types/react/index.d.ts',
          name: 'RefAttributes'
        }],
        required: false,
        type: {
          name: 'Ref<unknown>'
        }
      }
    },
    extendedInterfaces: ['Attributes']
  };
} catch (e) {}